<template>
  <f7-page name="roomstate">
    <module-filter @change="onModuleChange"></module-filter>
    <div class="card">
      <div class="room-title">{{starttime}}到{{endtime}}各设备检查状态</div>
    </div>
    <div class="card" style="padding-top: 0px;padding-bottom: 0px;">
      <div class="list links-list">
        <ul>
          <li v-for="(item,index) in items" :key="index">
            <div class="top-box">
              <div class="name list-font-size" v-if="item.inspectObjectModel">
                {{item.inspectObjectModel.facilityName +
                " " +
                item.inspectObjectModel.productLine +
                " " +
                item.inspectObjectModel.workshopName}}
              </div>
              <div
                v-if="item.inspectTime"
                :class="['status',item.okNum===item.inspectTime?'status-green':'status-red','left-status']"
              >{{item.okNum===item.inspectTime? '正常':'异常'}}</div>
              <div
                :class="['status',item.inspectTime?'status-green':'status-red']"
              >{{item.inspectTime? '已巡检':'未巡检'}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { f7Page } from "framework7-vue";
import ModuleFilter from "@/components/search/ModuleFilter";
import { fetchShopfloorStatus } from "@/api/computercheck.js";
export default {
  data() {
    return {
      checkNum: {
        type: Number,
        default: true
      },
      items: [],
      modulesUuid: "device",
      starttime: "",
      endtime: ""
    };
  },
  components: {
    ModuleFilter,
    [f7Page.name]: f7Page
  },
  methods: {
    getShopfloorStatus() {
      fetchShopfloorStatus({query:"week",year:new Date().getFullYear(),}, this.modulesUuid).then(({data}) => {
        this.starttime=data.startDate
        this.endtime=data.endDate
        this.items = data.statusList;
      });
    },
    onModuleChange(value) {
      this.modulesUuid = value;
      this.getShopfloorStatus();
    }
  },
  mounted() {
    document.title = "Shopfloor IT Devices Check";
    this.id = this.$f7route.query.id;
    this.getShopfloorStatus();
  }
};
</script>
<style lang="scss">
.room-title {
  text-align: center;
  font-size: 16px;
}
.list-font-size {
  font-size: 14px !important;
  line-height: 2.5;
}
</style>
<style scoped>
li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
li:last-child {
  border-bottom: none;
}
.left-status {
  margin-right: 10px;
}
</style>


